import request from '@/utils/request';

export function fetchDeliveryAppList(params) {
  return request({
    url: `/delivery-server/markets/${params.marketID}/apps`,
    method: 'get',
    params
  });
}

export function fetchDeliveryEnvList(params) {
  return request({
    url: `/delivery-server/markets/${params.marketID}/envs`,
    method: 'get',
    params
  });
}

export function fetchDeliveryRegionList(params) {
  return request({
    url: `/delivery-server/markets/${params.marketID}/regions`,
    method: 'get',
    params
  });
}

export function updateRegionStatus(params) {
  return request({
    url: `/delivery-server/markets/${params.marketID}/regions/${params.regionID}`,
    method: 'put',
    data: {
      enable: params.enable
    }
  });
}

export function createDeliveryEnv(params) {
  return request({
    url: `/delivery-server/markets/${params.marketID}/envs`,
    method: 'post',
    data: {
      name: params.name,
      token: params.token,
      url: params.url,
      envType: params.envType,
      platformURL: params.platformURL
    }
  });
}

export function updateDeliveryEnv(params) {
  return request({
    url: `/delivery-server/markets/${params.marketID}/envs/${params.envID}`,
    method: 'put',
    data: {
      name: params.name,
      token: params.token,
      url: params.url,
      envType: params.envType,
      platformURL: params.platformURL
    }
  });
}

export function syncDeliveryEnvRegion(params) {
  return request({
    url: `/delivery-server/markets/${params.marketID}/envs/${params.envID}/sync`,
    method: 'post',
    data: {}
  });
}

// 交付应用列表
export function getDeliveryAppListApi(params) {
  return request({
    url: `/delivery-server/markets/${params.marketID}/deliveryapps`,
    method: 'get',
    params
  });
}
// 交付应用详情
export function getDeliveryAppDetailApi(params) {
  return request({
    url: `/delivery-server/markets/${params.marketID}/deliveryapps/${params.appID}`,
    method: 'get'
  });
}

// 更换交付APP状态
export function changeDeliveryAppStApi(params) {
  let url = `/delivery-server/markets/${params.marketID}/deliveryapps/${params.appID}/start`;
  if (params.status == 'running') {
    url = `/delivery-server/markets/${params.marketID}/deliveryapps/${params.appID}/stop`;
  }
  return request({
    url: url,
    method: 'POST',
    data: {}
  });
}
// 更新、构建APP
export function updateOrBuildAppApi(params) {
  let url = `/delivery-server/markets/${params.marketID}/deliveryapps/${params.appID}/upgrade`;
  if (params.type == 'build') {
    url = `/delivery-server/markets/${params.marketID}/deliveryapps/${params.appID}/build`;
  }
  return request({
    url: url,
    method: 'POST',
    data: {}
  });
}
// 租户列表
export function getDeliveryTenantsListApi(params) {
  return request({
    url: `/delivery-server/markets/${params.marketID}/tenants`,
    method: 'get',
    params
  });
}

// 以下API全部失效

// 交付应用详情
export function fetchDeliveryAppsInfo(params) {
  return request({
    url:
      '/ajax/enterprises/' +
      params.eid +
      '/market/deliverapps/' +
      params.deliverID,
    method: 'get'
  });
}

// 查询交付客户应用列表
export function fetchCustomerList(params) {
  return request({
    url: '/ajax/enterprises/' + params.ID + '/customers',
    method: 'get',
    params
  });
}
// 删除交付用户
export function deleteCustomer(data) {
  return request({
    url: '/ajax/enterprises/' + data.EID + '/customers/' + data.customerID,
    method: 'post',
    data: data
  });
}

// 添加交付客户应用列表
export function addCustomerDeliveryUser(data) {
  return request({
    url: '/ajax/enterprises/' + data.ID + '/customers',
    method: 'post',
    data: data
  });
}
// 修改交付操作
export function operationDeliveryApps(params) {
  return request({
    url:
      '/delivery-server/markets/' +
      params.marketID +
      '/deliveryapps/' +
      params.appID +
      '/' +
      params.action,
    method: 'post',
    data: {}
  });
}
// 修改释放应用操作
export function putReleaseApplication(data) {
  return request({
    url:
      '/delivery-server/markets/' +
      data.marketID +
      '/deliveryapps/' +
      data.appID +
      '/release',
    method: 'post',
    data
  });
}
// 获取 商店端 域名
export function getStoreDeliveryDomains(params) {
  return request({
    url:
      '/delivery-server/markets/' +
      params.marketID +
      '/deliveryapps/' +
      params.appID +
      '/domains',
    method: 'get'
  });
}
// 获取 企业端 域名
export function getEnterpriseDeliveryDomains(params) {
  return request({
    url: '/delivery-server/customers/deliveryapps/' + params.appID + '/domains',
    method: 'get'
  });
}

export function getStoreDeilveryAppsMonitoring(params) {
  return request({
    url:
      '/delivery-server/markets/' +
      params.marketID +
      '/deliveryapps/' +
      params.appID +
      '/metrics',
    method: 'get'
  });
}

export function getEnterpriseDeilveryAppsMonitoring(params) {
  return request({
    url: '/delivery-server/customers/deliveryapps/' + params.appID + '/metrics',
    method: 'get'
  });
}

// 绑定域名（商店端）
export function getStoreDeliveryBindingDomains(data) {
  return request({
    url:
      '/delivery-server/markets/' +
      data.marketID +
      '/deliveryapps/' +
      data.appID +
      '/domains',
    method: 'post',
    data
  });
}
// 绑定域名（企业端）
export function getEnterpriseDeliveryBindingDomains(data) {
  return request({
    url: '/delivery-server/customers/deliveryapps/' + data.appID + '/domains',
    method: 'post',
    data
  });
}

export function getOverviewAppList() {
  return request({
    url: `/delivery-server/customers/indexapps`,
    method: 'get'
  });
}

export function fetchDeliveryAppStatus(params) {
  return request({
    url:
      '/ajax/enterprises/' +
      params.eid +
      '/delivers/' +
      params.orderID +
      '/status',
    method: 'get',
    params
  });
}

export function fetchDeliveryAppDomain(params) {
  return request({
    url:
      '/ajax/enterprises/' +
      params.eid +
      '/delivers/' +
      params.orderID +
      '/domain',
    method: 'get',
    params
  });
}

export function getOverviewAboutDelivery(data = {}) {
  return request({
    url: `/delivery-server/markets/${data.marketID}/overview`,
    method: 'GET'
  });
}


export function appReDelivery(data = {}) {
  return request({
    url: `/delivery-server/markets/${data.marketID}/deliveryapps/${data.appID}/redelivery`,
    method: 'POST',
    data: {}
  });
}



// WEBPACK FOOTER //
// ./src/api/delivery.js